module.exports = __webpack_public_path__ + "img/icon-weixin@3x.872b713b.png";